import React from "react";
import { List, Datagrid, TextField ,ReferenceField } from 'react-admin';

import {
    HasCustomerTypeFilter , 
    HasCountFilter ,
    HasAgeFilter ,
    HasGenderFilter ,
    HasMealFilter
} from './filters';
import { Card as MuiCard, CardContent, withStyles } from '@material-ui/core';

// 필터 Aside Style , Position ...
const Card = withStyles(theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            order: -1, // display on the left rather than on the right of the list
            width: '15em',
            marginRight: '1em',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}))(MuiCard);

const FilterSidebar = () => (
    <Card>
        <CardContent>
            <HasCustomerTypeFilter />
            <HasCountFilter />
            <HasAgeFilter />
            <HasGenderFilter />
            <HasMealFilter />
        </CardContent>
    </Card>
);

export const ReviewDataList = (props) => (
    <React.Fragment>
 
    <List  aside={<FilterSidebar />} {...props} perPage={25}>
        <Datagrid >
            <TextField source="supplierName" label="공급자" />
            <TextField source="menuName" label="메뉴명" />
            <TextField source="avgRating" label="평점"/>
            <TextField source="reviewCode1" label="간이 딱 맞아요"/>
            <TextField source="reviewCode2" label="비주얼이 좋아요"/>
            <TextField source="reviewCode3" label="간편해서 좋아요"/>
            <TextField source="reviewCode4" label="양이 적당해요"/>
            <TextField source="reviewCode5" label="건강해서 좋아요"/>
            <TextField source="reviewCode6" label="구성이 좋아요"/>
        </Datagrid>
    </List>
                       
    </React.Fragment>
);
export default ReviewDataList;